import workItemDlgMul from "./workItemDlgMul.js";
import businessScopeDlgMul from "./businessScopeDlgMul.js";
import workTmplDlg from "./workTmplDlg.js";

const qualityMan = {
  namespaced: true,
  modules: {
    workItemDlgMul,
    businessScopeDlgMul,
    workTmplDlg
  }
};

export default qualityMan;
